export const authenticationServiceUnavailableError =
  "Authentication service is temporarily unavailable. Please try again.";

export const authenticationRateLimitedError =
  "Too many sign-in attempts. Try again later.";

type ExternalAuthError = {
  code?: unknown;
  message?: unknown;
  name?: unknown;
  status?: unknown;
};

function normalizedString(value: unknown) {
  return typeof value === "string" ? value.trim().toLowerCase() : "";
}

export function isAuthenticationRateLimitError(error: unknown) {
  if (!error || typeof error !== "object") return false;
  const candidate = error as ExternalAuthError;
  const code = normalizedString(candidate.code);
  const message = normalizedString(candidate.message);
  const status = Number(candidate.status);

  return (
    status === 429 ||
    code.includes("rate_limit") ||
    message.includes("rate limit") ||
    message.includes("too many requests")
  );
}

export function isAuthenticationProviderError(error: unknown) {
  if (!error || typeof error !== "object") return false;
  const candidate = error as ExternalAuthError;
  const code = normalizedString(candidate.code);
  const message = normalizedString(candidate.message);
  const name = normalizedString(candidate.name);
  const status = Number(candidate.status);

  return (
    name === "authretryablefetcherror" ||
    status === 0 ||
    status >= 500 ||
    code.includes("timeout") ||
    code.includes("fetch") ||
    message.includes("fetch failed") ||
    message.includes("failed to fetch") ||
    message.includes("network") ||
    message.includes("timed out") ||
    message.includes("timeout") ||
    message.includes("aborted") ||
    message.includes("service unavailable") ||
    message.includes("gateway timeout")
  );
}

export function authenticationProviderFailure() {
  return {
    ok: false as const,
    status: 503 as const,
    error: authenticationServiceUnavailableError,
  };
}

export function authenticationRateLimitFailure() {
  return {
    ok: false as const,
    status: 429 as const,
    error: authenticationRateLimitedError,
  };
}
